import React from "react";
import CustomIcon from "../CustomIcon";

function Dot(props) {
  return (
    <CustomIcon
      icon={props.active ? "activeDot" : "dot"}
      width={11}
      height={11}
    />
  );
}

export default Dot;
